import React, { Component } from 'react';
import './logoSection.css';
import DesignSection from './designSection';
import SectionBanner from './sectionBanner';
import SectionPageHeader from './sectionPageHeader';

export default class AISection extends Component {
  render() {
    return (
      <div className="sectionContainer full-width">
        <SectionBanner image="/images/background-lines-gradient-purple.webp" title="AI Design Tools" />
        <SectionPageHeader description="A curated set of resources for using AI in your design and product workflow — from UI generation tools like Figma Make, Lovable, and Stitch to image generation, Claude skills, and prompt templates for PMs and designers." />
        <DesignSection
          title={'Resources'}
          subtitle={"Whether you're generating UI with Lovable, ideating visuals with image gen tools, or using Claude to review designs and draft specs — this is your starting point. Resources here are vetted and maintained by the design team."}>
          <div className="row medium-bottom-margin" style={{ alignItems: 'flex-start' }}>
            <div className="small-padding primary-background-subtle primary-color-dark" style={{ borderRadius: '12px', display: 'flex', alignItems: 'flex-start', gap: '12px', maxWidth: '480px' }}>
              <span className="material-symbols-rounded primary-color" style={{ fontSize: '24px', flexShrink: 0 }}>construction</span>
              <div>
                <p style={{ margin: 0, fontWeight: 600, opacity: 1 }}>{'Coming Soon'}</p>
                <p style={{ margin: 0 }}>{'AI design resources are currently under construction. Check back soon for tool guides, Claude skills, prompt templates, and more.'}</p>
              </div>
            </div>
          </div>
        </DesignSection>
      </div>
    );
  }
}
